// SPDX-FileCopyrightText: 2024 Tampere region
//
// SPDX-License-Identifier: LGPL-2.1-or-later

import type { CommonCustomizations } from 'lib-customizations/types'

import theme from './pirkkala-theme'

const customizations: CommonCustomizations = {
  theme
}

export default customizations
